import { render } from "./PlanosPagamento.vue?vue&type=template&id=1f2e6886&scoped=true"
import script from "./PlanosPagamento.vue?vue&type=script&lang=js"
export * from "./PlanosPagamento.vue?vue&type=script&lang=js"

import "./PlanosPagamento.vue?vue&type=style&index=0&id=1f2e6886&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2e6886"]])

export default __exports__